export default __webpack_public_path__ + "static/media/tpk-2024-take-off-card.201cb26f.webp";